"use strict";
exports.__esModule = true;
exports.TypographyEnum = void 0;
var TypographyEnum;
(function (TypographyEnum) {
    TypographyEnum["xxs"] = "xxs";
    TypographyEnum["xs"] = "xs";
    TypographyEnum["sm"] = "sm";
    TypographyEnum["base"] = "base";
    TypographyEnum["lg"] = "lg";
    TypographyEnum["xl"] = "xl";
    TypographyEnum["xxl"] = "xxl";
    TypographyEnum["3xl"] = "3xl";
    TypographyEnum["4l"] = "4xl";
    TypographyEnum["5l"] = "5xl";
    TypographyEnum["inherit"] = "inherit";
})(TypographyEnum = exports.TypographyEnum || (exports.TypographyEnum = {}));
//# sourceMappingURL=text.props.js.map